import script from "./ImportExcel.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportExcel.vue?vue&type=script&setup=true&lang=js"

import "./ImportExcel.vue?vue&type=style&index=0&id=4af6f2c6&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af6f2c6"]])

export default __exports__